import * as React from 'react';
/**
 * Make filters accessible to sub components
 */
export var FilterContext = React.createContext(undefined);
